import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { MatStepper } from "@angular/material/stepper";
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { ConfirmDialogModel } from "@shared/dialogs/confirm-dialog/confirm-dialog.component";

interface StepData {
  title: string;
  description: string;
  videoUrl: string;
}

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent {
  public dialogRef: MatDialogRef<NotificationDialogComponent> = inject(MatDialogRef);

  public formGroup: FormGroup;

  public steps: StepData[];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.steps = [
      {
        title: 'How to capture data',
        description: 'Body composition shows fat, muscle and water distribution. It\'s key to understanding metabolic balance and performance.',
        videoUrl: data.media[0].video_url,
      },
      {
        title: 'How to enter data',
        description: 'Body composition shows fat, muscle and water distribution. It\'s key to understanding metabolic balance and performance.',
        videoUrl: data.media[1].video_url,
      },
      {
        title: 'Additional guidance',
        description: 'Body composition shows fat, muscle and water distribution. It\'s key to understanding metabolic balance and performance.',
        videoUrl: data.media[2].video_url,
      }
    ];
    this.formGroup = this.fb.group({
      step1: new FormControl(''),
      step2: new FormControl(''),
      step3: new FormControl('')
    });
  }

  getStepControl(index: number): FormControl {
    return this.formGroup.get(`step${index + 1}`) as FormControl;
  }

  onCancel(): void {
    console.log('Cancel clicked');
  }

  onBack(stepper: MatStepper): void {
    stepper.previous();
  }

  onNext(stepper: MatStepper): void {
    stepper.next();
  }

  onFinish(): void {
    this.dialogRef.close(true);
  }

  isLastStep(stepper: MatStepper): boolean {
    return stepper.selectedIndex === this.steps.length - 1;
  }

  isFirstStep(stepper: MatStepper): boolean {
    return stepper.selectedIndex === 0;
  }
}
